import React from "react";
import RedirectToBookshelf from "../../common/ui/RedirectToBookshelf";
import { useBrand } from "../../common/providers/brand/brand-context";

export default function SystemError() {
  const brand = useBrand();
  const params = new URLSearchParams();
  params.set("locale", brand.getProp<string>("locale"));

  return (
    <RedirectToBookshelf
      path={`/error/system-error-space?${params.toString()}`}
      replace
    />
  );
}
